var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inscription),expression:"inscription"}],attrs:{"type":"text","maxlength":"80","placeholder":_vm.placeholder},domProps:{"value":(_vm.inscription)},on:{"input":function($event){if($event.target.composing)return;_vm.inscription=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }